import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import UserApi from '../server/UserApi';


function _handleSuccess (response) {
    CentricDispatcher.dispatch({
        type: ActionTypes.AUTH_INFO,
        data: response.data
    });
}
function _handleFormSuccess (response) {
    CentricDispatcher.dispatch({
        type: ActionTypes.AUTH_INFO,
        data: response.data
    });
    CentricDispatcher.dispatch({
        type: ActionTypes.FORM_SUBMIT_SUCCESS,
        data: response.data
    });
}
function _handleError (error) {
    CentricDispatcher.dispatch({
        type: ActionTypes.AUTH_INFO_ERROR,
        data: error
    });
}
export default {

    getCurrentUser: function() {
        return UserApi.getCurrentUser()
            .then(_handleSuccess,_handleError)
            .catch(_handleError);
    },
    updateProfile: function(data) {
        return UserApi.updateProfile(data)
            .then(_handleFormSuccess, _handleError)
            .catch(_handleError);
    }
};
